<template>
  <div class="product-format-trade">
    <product-format
      v-for="(product, index) in product_formats.dp"
      :key="index"
      :product="product"
      trade
    ></product-format>
  </div>
</template>

<script>
import Vue from "vue";
import { TabsPlugin } from "bootstrap-vue";

import ProductFormat from "@/components/ProductFormatNormalised";

Vue.use(TabsPlugin);

export default {
  data() {
    return {
      product_formats: { dp: [], ib: [] },
    };
  },
  components: {
    ProductFormat,
  },
  mounted() {
    this.product_formats = JSON.parse(this.formats);
    // var items = [];

    // for(var duty in this.product_formats) {
    //   for(var i in this.product_formats[duty]) {
    //   items.push({
    //       id: this.product_formats[duty][i].id,
    //       name: this.product_formats[duty][i].title,
    //       list_name: "Product Duty Tabs",
    //       brand: "Google",
    //       category: "Apparel/T-Shirts",
    //       variant: "Black",
    //       list_position: 1,
    //       quantity: 2,
    //       price: 2,
    //   });
    //   }
    // }

    // gtag("event", "select_content", {
    //   content_type: "product",
    //   items: items,
    // });
  },
  props: {
    currentDuty: {
      type: String,
      default: "DP",
    },
    productId: String,
    formats: String,
  },
};
</script>